export const Emitters = {
    dispatchConvertIcons(el) {
        el.dispatchEvent(new Event('convertIcons', { bubbles: true }) );
    },
    dispatchFeaturedChange(el) {
        el.dispatchEvent(new Event('featuredChange', { bubbles: true }) );
    },
    dispatchFilterChange(el, bubbles = true) {
        el.dispatchEvent(new Event('filterChange', { bubbles }));
    },
    dispatchDatepickerSelect(el, data, bubbles = true) {
        el.dispatchEvent(new CustomEvent('datepickerSelect', { bubbles, detail: data }));
    },
    dispatchDatepickerClear(el, bubbles = true) {
        el.dispatchEvent(new Event('datepickerClear', { bubbles }));
    },
    dispatchFetchComplete(el, data, bubbles = true) {
        el.dispatchEvent(new CustomEvent('fetchComplete', { bubbles, detail: data }));
    },
}